// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Entity Type
 * @export
 * @enum {string}
 */
export var EntityType;
(function (EntityType) {
    EntityType["Fund"] = "Fund";
    EntityType["Portfolio"] = "Portfolio";
    EntityType["Asset"] = "Asset";
    EntityType["Manager"] = "Manager";
    EntityType["Market"] = "Market";
    EntityType["FundSeries"] = "FundSeries";
})(EntityType || (EntityType = {}));
export function EntityTypeFromJSON(json) {
    return json;
}
export function EntityTypeToJSON(value) {
    return value;
}
